import { useEffect, useRef , useState} from "react"
export const useWindowSize = ()=>{ 
    const [siz, setSiz] = useState([window.innerWidth, window.innerHeight]);
    function updateS(){
        setSiz([window.innerWidth, window.innerHeight]);
    }
    useEffect(()=>{ 
      window.addEventListener("resize",  updateS );
      return ()=>{ 
        window.removeEventListener("resize", updateS )
      };  
    })
    return siz;
}
export const useDocumentSize = ()=>{ 
    const [siz, setSiz] = useState([document.body.clientWidth, document.body.clientHeight]);
    function updateS(){
        setSiz([document.body.clientWidth, document.body.clientHeight]);
    }
    useEffect(()=>{ 
      window.addEventListener("resize",  updateS );
      return ()=>{ 
        window.removeEventListener("resize", updateS )
      };  
    })
    return siz;
}

export const useMaxSize = ({ref})=>{ 
    const windowSize = useWindowSize();
    let maxSize = [...windowSize];
    if(ref && ref.current){
        const ms =  ref.current.getBoundingClientRect();
        maxSize = [windowSize[0]- ms.left. windowSize[1]-ms.top];
    }
    return maxSize;
}